import { render, staticRenderFns } from "./AddSong.vue?vue&type=template&id=44355b8e&scoped=true&"
import script from "./AddSong.vue?vue&type=script&lang=js&"
export * from "./AddSong.vue?vue&type=script&lang=js&"
import style0 from "./AddSong.vue?vue&type=style&index=0&id=44355b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44355b8e",
  null
  
)

export default component.exports